import { Label, Layout, Panel, Tree } from "@mcleod/components";

export abstract class AutogenLayoutDemo extends Layout {
    labelAvailableDemos: Label;
    labelSelectOne: Label;
    panelContent: Panel;
    panelLeft: Panel;
    treeDemo: Tree;
}
